var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('recovery', {
    attrs: {
      "onRecovery": _vm.recovery
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ac4a0fb","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/Recovery/RecoveryContainer.vue
// module id = 863
// module chunks = 0